import App from '@/components/App'

export default (createElement) => createElement(App)
